export default {"src":"/_next/static/media/close-green.a6b1a6f4.svg","height":8,"width":8};